import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userRoles } from "../../../helpers/constant";
import { validateUserRole } from "../../../helpers/helpers";
import { useFacilities } from "../hooks/useFacilities";
import FacilitySearchBar from "../components/list/FacilitySearchBar";
import FacilityTable from "../components/list/FacilityTable";
import FacilityPagination from "../components/list/FacilityPagination";
import FacilityDrawer from "../components/drawer/FacilityDrawer";

const FacilityListPage = () => {
  const {
    facilities,
    total,
    isLoading,
    search,
    setSearch,
    status,
    setStatus,
    page,
    setPage,
    limit,
    setLimit,
    totalPages,
    refetch,
  } = useFacilities();
  const [drawerFacility, setDrawerFacility] = useState(undefined); // undefined = closed, null = add, object = edit
  const navigate = useNavigate();

  const canAddFacility = validateUserRole(userRoles.SUPERADMIN);

  const handleSaved = () => {
    refetch();
  };

  return (
    <div className="flex h-full flex-col pt-4 lg:h-[calc(100vh-100px)]">
      <div className="flex-shrink-0">
        <FacilitySearchBar
          search={search}
          onSearchChange={setSearch}
          status={status}
          onStatusChange={setStatus}
          onAddFacility={() => setDrawerFacility(null)}
          canAddFacility={canAddFacility}
        />
      </div>

      <FacilityTable
        facilities={facilities}
        isLoading={isLoading}
        onRowClick={(facility) => navigate(`/facility/${facility.id}`)}
        onEdit={(facility) => setDrawerFacility(facility)}
      />

      <div className="flex-shrink-0 pt-2">
        <FacilityPagination
          total={total}
          page={page}
          totalPages={totalPages}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={setLimit}
        />
      </div>

      {drawerFacility !== undefined && (
        <FacilityDrawer facility={drawerFacility} onClose={() => setDrawerFacility(undefined)} onSaved={handleSaved} />
      )}
    </div>
  );
};

export default FacilityListPage;
